import { __require as require_getNative } from './_getNative.js';
import { __require as require_root } from './_root.js';

var _Promise;
var hasRequired_Promise;

function require_Promise () {
	if (hasRequired_Promise) return _Promise;
	hasRequired_Promise = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');

	_Promise = Promise;
	return _Promise;
}

export { require_Promise as __require };
//# sourceMappingURL=_Promise.js.map
